import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolepermissionService } from 'src/app/services/rolepermission.service';

@Component({
  standalone: false,
  selector: 'app-remove-modal-user-role',
  templateUrl: './remove-modal-user-role.component.html',
  styleUrls: ['./remove-modal-user-role.component.scss'],
})
export class RemovemodaluserroleComponent implements OnInit {
  @Input() roleMappingId: string;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private rolepermissionService: RolepermissionService,
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit(): void { }

  removeRoleFromUser() {
    this.rolepermissionService
      .removeUserRolePermission(this.roleMappingId)
      .subscribe((res) => {
        this.modalService.dismissAll();
        this.activeModal.dismiss();
        setTimeout(() => {
          window.location.reload();
        }, 5000);
        // this.router.navigate(['/role-permission/']);
      });
  }
}
